import  { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import download from "../../assests/download.gif"
 
 
const DownloadWithPopup = ({ jobId,jobName,fileId,fileCount, onConfirm, className, children,
  customDetailsJSX = null, 
  title = "Download report",
  headingText = "Your database migration report is ready!",
  detailsText = `Details : Job Name: ${jobName} Processed: ${fileCount} files`,
  confirmText = "Proceed with download?"

 }) => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
 
  const handleShow = (e) => {
    e.preventDefault();
    setShow(true);
  };
 
  const handleClose = () => setShow(false);
 
  const handleConfirmDownload = () => {
    onConfirm(jobId,fileId);
    handleClose();
  };
 
  return (
    <>
      <a href="#" onClick={handleShow} className={className}>
        {children}
      </a>
 
    <Modal show={show} onHide={handleClose} centered>
  <Modal.Header closeButton style={{ border: "0px" }}>
    <Modal.Title className="title_styles">{title}</Modal.Title>
  </Modal.Header>
  <Modal.Body className="d-flex align-items-start">
    <img
      src={download}
      alt="download-icon"
      width="83"
      height="78"
      className="me-3 image-styles"
    />
    <div>
      <p className="p_styles">{headingText}</p>

      {/** If `customDetailsJSX` is passed, render that. Else fallback to default details with bold job name and processed count. */}
      {customDetailsJSX ? (
        customDetailsJSX
      ) : (
        <p className="p_styles">
          <strong>Details : Job Name:</strong> {jobName}{" "}
          {typeof fileCount !== "undefined" && (
            <>
              <strong>Processed:</strong> {fileCount} files
            </>
          )}
        </p>
      )}

      <p className="p_styles">{confirmText}</p>
    </div>
  </Modal.Body>
  <Modal.Footer className="footer_styles">
    <Button
      className="btn btn-closebtn custom-button"
      variant="secondary"
      onClick={handleClose}
    >
      Close
    </Button>
    <Button
      variant="primary"
      className="btn btn-primary custom-button"
      onClick={handleConfirmDownload}
    >
      Download
    </Button>
  </Modal.Footer>
</Modal>

    </>
  );
};
 
export default DownloadWithPopup;
